
import { useState } from "react";
import { useAuth } from "@/contexts/auth";
import { usePermissions } from '@/services/permissionHelper';
import { useLocation } from "react-router-dom";
import BrandLogo from "./navbar/BrandLogo";
import DesktopNav from "./navbar/DesktopNav";
import MobileMenu from "./navbar/MobileMenu";
import AdminMobileMenu from "./navbar/AdminMobileMenu";
import LanguageSwitcher from "./LanguageSwitcher";

const Navbar = () => {
  const { user, signOut } = useAuth();
  const { isAdmin } = usePermissions();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  // Check if current path is in admin area
  const isAdminPage = location.pathname.startsWith('/admin');
  
  return (
    <header className="sticky top-0 z-50 w-full border-b border-brand-cloud bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80" data-test-responsive="navbar">
      <div className="container mx-auto flex h-14 items-center gap-4 px-2 sm:px-4 md:h-16">
        {/* Logo - give it more space on mobile */}
        {!isAdminPage && <BrandLogo className="flex-shrink-0 min-w-0" />}
        {isAdminPage && <div className="invisible" />} {/* Empty div to maintain spacing */}
        
        {/* Desktop Navigation - hidden on mobile */}
        <div className="hidden min-w-0 flex-1 items-center gap-4 md:flex">
          <DesktopNav />
          <LanguageSwitcher />
        </div>
        
        {/* Mobile Navigation - Language switcher + Menu */}
        <div className="ml-auto flex flex-shrink-0 items-center gap-2 md:hidden">
          <LanguageSwitcher />
          {isAdminPage && isAdmin ? (
            <AdminMobileMenu 
              user={user}
              signOut={signOut}
              isOpen={mobileMenuOpen}
              setIsOpen={setMobileMenuOpen}
            />
          ) : (
            <MobileMenu 
              user={user}
              isAdmin={isAdmin}
              signOut={signOut}
              isOpen={mobileMenuOpen}
              setIsOpen={setMobileMenuOpen}
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
